import { Card, Text } from '@shopify/polaris';
import { StatusBadge } from './StatusBadge';

export function MetricCard({
  label,
  value,
  summary,
  status,
  footer,
}: {
  label: string;
  value: string;
  summary?: string;
  status?: string | null;
  footer?: string;
}) {
  return (
    <Card>
      <div className="metric-card">
        <div className="metric-card__header">
          <Text as="h3" variant="bodyMd" tone="subdued">{label}</Text>
          <StatusBadge status={status} />
        </div>
        <Text as="p" variant="heading2xl">{value}</Text>
        {summary ? <Text as="p" variant="bodyMd" tone="subdued">{summary}</Text> : null}
        {footer ? <Text as="p" variant="bodySm" tone="subdued">{footer}</Text> : null}
      </div>
    </Card>
  );
}
